import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import CalendarViewModel from '@/ViewModels/Controls/CalendarViewModel';
import Calendar from '@/Controls/Calendar';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';
import * as DateHelper from '@/Utility/DateHelper';

export default class CalendarFactory extends ControlFactory {

    /**
     * @override
     */
    control: Calendar;
    private jQueryControl: JQuery;
    private CalendarViewModel = ComponentManager.getViewModel<typeof CalendarViewModel>('CalendarViewModel');
    private Calendar = ComponentManager.getControl<typeof Calendar>('Calendar');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: CalendarViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.CalendarViewModel({
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isFocusable: this.isFocusable,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name)
        });

        this.control = new this.Calendar(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    public getValueForFilter(): Object {
        var ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);

        return ret;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: DateHelper.toDotNetDateTimeString(this.viewModel?.date()) || ''
        }
    }
}

ComponentManager.setFactory('Calendar', CalendarFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');